import AffiliateLandingPage from '@layouts/AffiliateLandingPage';
import { setRedirectionLink } from '@store/actions';
import { DispatchContext } from '@store/store';
import React, { useContext, useEffect } from 'react';

const pageData = {
  firstName: 'Mari',
  lastName: 'Smith',
  mainSection: {
    name: 'Mari Smith',
    percentage: '30',
    getOfferTxt: "GET MARI'S OFFER",
    title: 'Welcome friends of Mari Smith!',
    subTitle: 'Your search for the easiest video editor ends here!',
    offerSubTitle: 'Exclusive Mari Smith Offer',
    offerTitle: 'Enjoy 25% Off!',
    mainBgImg: {
      desktop:
        'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/marismith-bg.jpg',
      mobile:
        'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/marismith-mobile-bg.jpg',
    },
  },
  section2: {
    circularImg: false,
    imgCircle: {
      webp: 'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/mari-saying.webp',
      jpg: 'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/mari-saying.png',
      alt: 'Mari Smith invideo',
    },
    content: {
      title:
        'Create stunning short form videos for your brand with Mari Smith, the queen of Facebook!',
      p1: '',
      p2: "Scrolling through Reels on Instagram and Facebook is no longer just a fun way to spend your time on the internet. The popularity of Reels has soared so high, that if you're not actively creating content for it, you're missing out!",
      p3: "But, these short form videos are time-consuming to create. That's where invideo comes in! Create thumb-stopping Reels quickly and easily. The best part? You don't need any prior video editing experience.",
      // p4: 'That’s where InVideo comes in! Create thumb-stopping videos in under 15 mins without no prior video editing experience with the world’s first Intelligent Video editor.',
    },
    creatorLink: '/creator/marismith',
  },
  section3: {
    para: "Reels have quickly become one of the most effective formats to not just capture your audience's attention, but also grow your audience rapidly. With invideo, you've got a powerful tool that lets you create Reels in minutes without needing any prior video editing experience. And, you can get a year's worth of videos for just $15 a month! I personally love using invideo and has made my workflow so much more streamlined.",
    img: {
      webp: 'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/mari-saying.webp',
      jpg: 'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/mari-saying.png',
      alt: 'Mari Smith invideo',
    },
  },
  pricing: {
    business: {
      discount: 30,
    },
    unlimited: {
      discount: 30,
    },
  },
  lastSection: {
    img: {
      webp: 'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/mari-smith-bottom.webp',
      png: 'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/mari-smith-bottom.png',
    },
  },
};

const cookie = {
  coupon: 'MARI30',
  response: {
    fixed_discount: false,
    amount: 0,
    percent: 30,
    type: 'discount',
    status: 'success',
    referral_id: '',
  },
  duration: true,
};

function Marismith() {
  const dispatch = useContext(DispatchContext);
  useEffect(() => {
    dispatch(
      setRedirectionLink(
        `/sign-up?otherUrl=/payments/checkout&coupon=${cookie.coupon}`,
      ),
    );
  }, []);

  return (
    <AffiliateLandingPage
      pageData={pageData}
      seo={{
        Title: 'Mari Smith | invideo',
        Description:
          'This service allows you convert online image to video, you can now create a video online from your pictures and music.',
        CanonicalURL: 'https://invideo.io/marismith/',
        Keywords: '',
        Hreflang: [],
        Meta: [],
        id: 0,
        RobotIndex: 'noindex',
        RobotFollow: 'nofollow',
      }}
    />
  );
}

export default Marismith;
